import React from 'react';
import Spinner from 'react-spinkit';


const LongBadgeClientComponent = ({ name, dashboardClients, is_loading }) => {

    const getProgressValueNew = () => {
        let progressValueNew = 100;
        if (dashboardClients.previous_count > 0) {
            progressValueNew = dashboardClients.new_count / dashboardClients.previous_count * 100;
            if (dashboardClients.new_count === 0) {
                progressValueNew = 0;
            }
        }
        return progressValueNew;
    }

    const getProgressValueLost = () => {
        let progressValueLost = 0;
        if (dashboardClients.previous_count > 0) {
            progressValueLost = dashboardClients.lost_count / dashboardClients.previous_count * 100;
            if (dashboardClients.lost_count === dashboardClients.previous_count) {
                progressValueLost = 100;
            }
        }
        return progressValueLost;
    }

    return <div className='cards-badge' >
        <div className='cards-badge-header'>
            <p>{name}</p>
        </div>
        <div className='cards-badge-body'>
            {is_loading ? (
                    <div
                        className='spinner-loading'
                        style={{ paddingTop: '15px', paddingBottom: '65px', textAlign: 'center' }}
                    >
                        <Spinner name='folding-cube' fadeIn='none' />
                    </div>
            ) : (
                <>
                    <div className='cards-long-badge-text'>
                        <p className='cards-title-name'>приобрели</p>
                        <p className={`cards-badge-value__small`}>{Math.floor(dashboardClients.new_count || 0).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')}</p>
                        <p className={`cards-income-change cards-income-increase`}>{Math.floor(getProgressValueNew()).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')} %</p>
                    </div>

                    <div className='cards-long-badge-text'>
                        <div className='cards-divider'></div>
                    </div>
                    <div className='cards-long-badge-text'>
                        <p className='cards-title-name'>потеряли</p>
                        <p className={`cards-badge-value-prev__small`}>{Math.floor(dashboardClients.lost_count || 0).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')}</p>
                        <p className={`cards-income-change cards-income-decrease`}>{Math.floor(getProgressValueLost()).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')} %</p>
                    </div>
                </>
            )}
        </div>
    </div>;
};


export default LongBadgeClientComponent;